export const actionTypes = {
  PAGE_ONE: 'PAGE_ONE',
  PAGE_TWO: 'PAGE_TWO',
  PAGE_THREE: 'PAGE_THREE',
  PAGE_FOUR: 'PAGE_FOUR',
  PAGE_FIVE: 'PAGE_FIVE',
  PAGE_SIX: 'PAGE_SIX',
  PAGE_SEVEN: 'PAGE_SEVEN',
  PAGE_EIGHT: 'PAGE_EIGHT',
  PAGE_NINE: 'PAGE_NINE',
  PAGE_TEN: 'PAGE_TEN',
  PAGE_ELEVEN: 'PAGE_ELEVEN',
  PAGE_TWELVE: 'PAGE_TWELVE',
  PAGE_THIRTEEN: 'PAGE_THIRTEEN',
  PAGE_FOURTEEN: 'PAGE_FOURTEEN',
  PAGE_FIFTEEN: 'PAGE_FIFTEEN',
  PAGE_SIXTEEN: 'PAGE_SIXTEEN',
  PAGE_SEVENTEEN: 'PAGE_SEVENTEEN',
  PAGE_EIGHTEEN: 'PAGE_EIGHTEEN',
  PAGE_NINETEEN: 'PAGE_NINETEEN',
  PAGE_TWENTY: 'PAGE_TWENTY',
  PAGE_TWENTY_ONE: 'PAGE_TWENTY_ONE',
};

export const actionTypesForExistingPatient = {
  EXPERIENCING: 'EXPERIENCING',
  SYMPTOMS_STILL_EXPERIENCING: 'SYMPTOMS_STILL_EXPERIENCING',
  CURRENT_PAIN_LEVEL: 'CURRENT_PAIN_LEVEL',
};

export const actionTypesOfReasonForVisit = {
  REASON_FOR_VISIT: 'REASON_FOR_VISIT',
  REASON_FOR_VISIT_CONT: 'REASON_FOR_VISIT_CONT',
  WHICH_FOOT: 'WHICH_FOOT',
  SHOE_SIZE: 'SHOE_SIZE',
  WHERE_ON_THE_FOOT: 'WHERE_ON_THE_FOOT',
  DIAGNOSIS_UPLOAD_PHOTO: 'DIAGNOSIS_UPLOAD_PHOTO',
  HOW_LONG_EXPERIENCING_PROBLEM: 'HOW_LONG_EXPERIENCING_PROBLEM',
  CONSISTENTLY_OR_OFF_PROBLEM: 'CONSISTENTLY_OR_OFF_PROBLEM',
  HOW_DID_IT_START: 'HOW_DID_IT_START',
  WHAT_TYPE_OF_PAIN: 'WHAT_TYPE_OF_PAIN',
  WHAT_ARE_YOUR_SYMPTOMS: 'WHAT_ARE_YOUR_SYMPTOMS',
  PAIN_WORST: 'PAIN_WORST',
  WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER:
    'WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER',
  TREATMENTS_TRIED_HOME: 'TREATMENTS_TRIED_HOME',
  SEEN_OTHER_PROVIDERS: 'SEEN_OTHER_PROVIDERS',
  WHAT_TREATMENTS_DID_PROVIDER: 'WHAT_TREATMENTS_DID_PROVIDER',
  HOW_LONG_DID_PHYSICAL_THERAPY: 'HOW_LONG_DID_PHYSICAL_THERAPY',
  WHAT_TREATMENTS_WERE_HELPFUL: 'WHAT_TREATMENTS_WERE_HELPFUL',
};

export const actionTypesOfNonPodiatry = {
  REASON_FOR_VISIT: 'REASON_FOR_VISIT',
  WHICH_SIDE: 'WHICH_SIDE',
  SHOE_SIZE: 'SHOE_SIZE',
  WHERE_ON_THE_FOOT: 'WHERE_ON_THE_FOOT',
  DIAGNOSIS_UPLOAD_PHOTO: 'DIAGNOSIS_UPLOAD_PHOTO',
  HOW_LONG_EXPERIENCING_PROBLEM: 'HOW_LONG_EXPERIENCING_PROBLEM',
  CONSISTENTLY_OR_OFF_PROBLEM: 'CONSISTENTLY_OR_OFF_PROBLEM',
  HOW_DID_IT_START: 'HOW_DID_IT_START',
  WHAT_TYPE_OF_PAIN: 'WHAT_TYPE_OF_PAIN',
  WHAT_ARE_YOUR_SYMPTOMS: 'WHAT_ARE_YOUR_SYMPTOMS',
  PAIN_WORST: 'PAIN_WORST',
  WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER:
    'WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER',
  TREATMENTS_TRIED_HOME: 'TREATMENTS_TRIED_HOME',
  SEEN_OTHER_PROVIDERS: 'SEEN_OTHER_PROVIDERS',
  WHAT_TREATMENTS_RECOMMENDED_PRE_PROVIDER:
    'WHAT_TREATMENTS_RECOMMENDED_PRE_PROVIDER',
  HOW_LONG_DID_PHYSICAL_THERAPY: 'HOW_LONG_DID_PHYSICAL_THERAPY',
  WHAT_TREATMENTS_WERE_HELPFUL: 'WHAT_TREATMENTS_WERE_HELPFUL',
};

export const actionTypeOfMedicalHistory = {
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  CONTACT_INFORMATION: 'CONTACT_INFORMATION',
  PHARMACY_INFORMATION: 'PHARMACY_INFORMATION',
  PRIMARY_CARE_PHYSICIAN: 'PRIMARY_CARE_PHYSICIAN',
  INSURANCE_ID: 'INSURANCE_ID',
  PHOTO_ID: 'PHOTO_ID',
  PERSONAL_INJURY: 'PERSONAL_INJURY',
  CREDIT_CARD: 'CREDIT_CARD',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  SURGICAL_HISTORY: 'SURGICAL_HISTORY',
  MEDICATIONS: 'MEDICATIONS',
  ALLERGIES: 'ALLERGIES',
  SOCIAL_HISTORY: 'SOCIAL_HISTORY',
  FAMILY_HISTORY: 'FAMILY_HISTORY',
  RELEVANT_MEDICAL_RECORDS: 'RELEVANT_MEDICAL_RECORDS',
  ANY_RECENT_ISSUES: 'ANY_RECENT_ISSUES',
  ANY_RECENT_ISSUES_PAGES: 'ANY_RECENT_ISSUES_PAGES',
  PATIENT_CONSENT: 'PATIENT_CONSENT',
};
